import React from 'react'
import { useTranslation } from 'react-i18next'

import './ElectronicCommunicationConsent.scss'

export const ElectronicCommunicationConsent = () => {
    const { t } = useTranslation()

    return (
        <div className="electronic-communication-consent">
            <h2>{t('ElectronicCommunicationConsent')}</h2>

            <p>
                {t('ElectronicCommunicationConsentDescription')}
            </p>
        </div>
    )
}